module.exports = __webpack_public_path__ + "media/cuttlefish/proBadge-00e74403.svg";